/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'project-contributors-picker.done': '完了',
  'project-contributors-picker.go-back-label': '戻る',
  'project-contributors-picker.header': 'プロジェクトのメンバーを選択',
  'project-contributors-picker.your-teams-secondary-text':
    '{membersCount, plural, other {{membersCount,number} 人のメンバー}}',
  'project-contributors-picker.your-teams-secondary-text-focused':
    '{membersCount, plural, other {{membersCount,number} 人のメンバーから選択}}',
  'project-contributors-picker.your-teams-title': 'あなたのチーム',
  'project-fields.common.generic-error.description': '接続を確認してもう一度お試しください。',
  'project-fields.common.generic-error.title': '問題が発生しました',
  'project-fields.link-item.delete-label': '削除',
  'project-fields.link-item.edit-label': '編集',
  'project-fields.project-contributes-to.add-goal-title': 'ゴールを追加',
  'project-fields.project-contributes-to.empty-title': 'ゴールがありません',
  'project-fields.project-contributes-to.title': '貢献対象',
  'project-fields.project-contributors.add-contributors-title': 'コントリビューターを追加',
  'project-fields.project-contributors.empty-title': '投稿者がいません',
  'project-fields.project-contributors.remove-contributor': 'コントリビューターを削除',
  'project-fields.project-contributors.remove-contributor-error-message': '投稿者を削除できませんでした',
  'project-fields.project-contributors.remove-team': 'チームを削除',
  'project-fields.project-contributors.show-more': 'さらに表示',
  'project-fields.project-contributors.title': '投稿者',
  'project-fields.project-contributors.view-profile': 'プロファイルを表示',
  'project-fields.project-contributors.view-profile-team': 'プロファイルを表示',
  'project-fields.project-focus-areas.title': 'フォーカス エリア',
  'project-fields.project-followers.add-followers-title': 'フォロワーを追加',
  'project-fields.project-followers.empty-title': 'フォロワーがいません',
  'project-fields.project-followers.title': 'フォロワー',
  'project-fields.project-link-picker.aria-label': '最近表示したリンク',
  'project-fields.project-link-picker.invalid-link-input.error': 'リンクの URL が有効かどうかを確認してください。',
  'project-fields.project-link-picker.link-input.clear-label': 'リンクをクリア',
  'project-fields.project-link-picker.link-input.placeholder': 'リンクを貼り付けるか、最近表示したページを検索',
  'project-fields.project-link-picker.text-input.clear-label': 'テキストを削除',
  'project-fields.project-link-picker.text-input.placeholder': '表示するテキスト (オプション)',
  'project-fields.project-links.add-links-title': 'リンクを追加',
  'project-fields.project-links.add-links-tooltip': 'ドキュメントやデザインなどのリンクを追加',
  'project-fields.project-links.delete-link-button': 'リンクを削除',
  'project-fields.project-links.edit-link-button': 'リンクを編集',
  'project-fields.project-links.empty-title': 'リンクがありません',
  'project-fields.project-links.title': 'リンク',
  'project-fields.project-owner.title': '所有者',
  'project-fields.project-start-date.add-start-date-title': '開始日を追加',
  'project-fields.project-start-date.cancel-button': '保存',
  'project-fields.project-start-date.creation-date': 'このプロジェクトは {creationDate} に作成されました',
  'project-fields.project-start-date.edit-start-date-label': 'プロジェクト開始日を編集',
  'project-fields.project-start-date.empty-title': '開始日がありません',
  'project-fields.project-start-date.enter-start-date-title': '開始日を入力',
  'project-fields.project-start-date.open-calendar-label': 'カレンダーを開く',
  'project-fields.project-start-date.read-only': '開始日を変更できるのは、編集権限を持つ投稿者のみです。',
  'project-fields.project-start-date.title': '開始日',
  'project-fields.project-state.archived': 'アーカイブ済み',
  'project-fields.project-state.at-risk': 'リスクあり',
  'project-fields.project-state.cancelled': 'キャンセル済み',
  'project-fields.project-state.completed': '完了 🎉',
  'project-fields.project-state.off-track': '遅延',
  'project-fields.project-state.on-track': '順調',
  'project-fields.project-state.paused': '一時停止中',
  'project-fields.project-state.pending': '保留中',
  'project-fields.project-status-picker.project-status-picker-more-button': 'その他のステータス',
  'project-fields.project-status.title': 'ステータス',
  'project-fields.project-tags.add-tags-title': 'タグを追加する',
  'project-fields.project-tags.empty-title': 'タグがありません',
  'project-fields.project-tags.title': 'タグ',
  'project-fields.project-target-date.picker-placeholder': '保留中',
  'project-fields.project-target-date.title': '期日',
  'project-fields.project-work-items.show-all-non-final': 'すべて表示',
  'project-fields.project-work-items.show-less-non-final': '表示を減らす',
  'project-fields.project-work-tracked-picker.cancel-button': '保存',
  'project-fields.project-work-tracked-picker.fallback-description':
    'このプロジェクトの作業を追跡する場所へのリンクを追加してください',
  'project-fields.project-work-tracked-picker.fallback-invalid-url': '有効な URL を入力してください',
  'project-fields.project-work-tracked-picker.no-recently-viewed-header': 'Jira 作業項目を検索',
  'project-fields.project-work-tracked-picker.no-recently-viewed-result':
    'このプロジェクトの作業を追跡している場所へのリンクを検索するか追加します。',
  'project-fields.project-work-tracked-picker.no-search-result':
    'Jira 作業項目のキーまたは URL を再度入力するか、別の検索語句を使用してみてください。',
  'project-fields.project-work-tracked-picker.no-search-results-header': '一致する結果が見つかりませんでした',
  'project-fields.project-work-tracked-picker.recently-viewed-title': '最近表示',
  'project-fields.project-work-tracked-picker.results-title': '検索結果',
  'project-fields.project-work-tracked-picker.search-placeholder': 'Jira を検索するかリンクを追加',
  'project-fields.project-work-tracked-picker.sync-form-description':
    '選択した Jira 作業項目にこのプロジェクトをリンクし、詳細を自動的に同期します。',
  'project-fields.project-work-tracked-picker.sync-form-warning':
    'この Jira 作業項目を閲覧できるすべてのユーザーにプロジェクトの詳細が表示されることにご注意ください。',
  'project-fields.project-work-tracked-picker.sync-with-jira-button': 'Jira と同期',
  'project-fields.project-work-tracked-picker.sync-with-jira-cancel-button': 'キャンセル',
  'project-fields.project-work-tracked-picker.sync-with-jira-connect-button': '接続',
  'project-fields.project-work-tracked-picker.sync-with-jira-detail-selection':
    '今後この業務に使用する詳細情報を選択してください。',
  'project-fields.project-work-tracked-picker.sync-with-jira-header': 'このプロジェクトを Jira と同期する',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing': 'ラベルの同期',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing-description':
    'Jira のラベルをプロジェクトのタグと同期する',
  'project-fields.project-work-tracked-picker.sync-with-jira-project-name': 'プロジェクト名',
  'project-fields.project-work-tracked-picker.sync-with-jira-start-date': '開始日',
  'project-fields.project-work-tracked-picker.sync-with-jira-target-date': '期日',
  'project-fields.project-work-tracked-picker.sync-with-jira-via-project': '{projectName} {viaProject}',
  'project-fields.project-work-tracked-picker.text-placeholder': '作業の追跡リンク',
  'project-fields.project-work-tracked-picker.work-tracked-picker-content':
    'Jira 作業項目を検索するか、このプロジェクトの作業を追跡している場所へのリンクを追加します。',
  'project-fields.project-work-tracked-picker.work-tracked-picker-title': '作業を追跡する場所',
  'project-fields.project-work-tracked.add-work-tracked-title': 'Jira 作業項目を追加',
  'project-fields.project-work-tracked.empty-title': 'Jira 作業項目がありません',
  'project-fields.project-work-tracked.linked-with-jira-label': 'Jira とリンク済み',
  'project-fields.project-work-tracked.sync-now-label': '今すぐ同期',
  'project-fields.project-work-tracked.synced-with-jira-label': 'Jira と同期済み',
  'project-fields.project-work-tracked.title': '追跡している作業',
  'project-fields.related-project-picker.add-button-label': '追加',
  'project-fields.related-project-picker.cancel-button-label': 'キャンセル',
  'project-fields.related-project-picker.depended-by-option-label': 'このプロジェクトに依存しているプロジェクト',
  'project-fields.related-project-picker.depends-on-option-label': 'このプロジェクトが依存しているプロジェクト',
  'project-fields.related-project-picker.empty-state-description':
    'このプロジェクトにリンクする関連プロジェクトを見つけましょう。',
  'project-fields.related-project-picker.empty-state-title': 'プロジェクトを検索',
  'project-fields.related-project-picker.project-relationship-type-label': 'プロジェクトの関係タイプを選択',
  'project-fields.related-project-picker.project-search-placeholder': 'プロジェクトを検索',
  'project-fields.related-project-picker.related-option-label': '関連するプロジェクト',
  'project-fields.related-project-picker.related-project-list-label': '関連プロジェクト',
  'project-fields.related-projects.add-related-title': '関連プロジェクトを追加',
  'project-fields.related-projects.add-related-tooltip': '依存関係があるプロジェクトまたは関連するプロジェクトを追加',
  'project-fields.related-projects.dependent-by-projects-heading': '依存元のプロジェクト',
  'project-fields.related-projects.dependent-on-projects-heading': 'このプロジェクトの依存先',
  'project-fields.related-projects.empty-title': '関連プロジェクトがありません',
  'project-fields.related-projects.related-projects-heading': '関連があるもの',
  'project-fields.related-projects.title': '関連するもの',
  'project-fields.use-project-flags.generic-error-description':
    '問題が発生しました。しばらくしてから再度お試しください。',
  'project-fields.use-project-flags.generic-error-title': '問題が発生しました',
  'project-fields.use-project-flags.project-links-add-failure-title': 'リンクを追加できませんでした',
  'project-fields.use-project-flags.project-links-delete-failure-title': 'リンクを削除できませんでした',
  'project-fields.use-project-flags.project-links-edit-failure-title': 'リンクを編集できませんでした',
  'project-fields.use-project-flags.project-owner-change-error-header': 'プロジェクト所有者を変更できませんでした',
  'project-fields.use-project-flags.project-start-date-change-error-header':
    'プロジェクトの開始日を更新できませんでした',
  'project-fields.use-project-flags.project-tags-add-failure-title': 'タグを追加できませんでした',
  'project-fields.use-project-flags.project-tags-create-failure-title': 'タグを作成できませんでした',
  'project-fields.use-project-flags.project-tags-create-limit-failure-description':
    '入力したタグ名が長すぎます。タグ名は 255 文字以下で入力してください。',
  'project-fields.use-project-flags.project-tags-create-limit-failure-title': 'タグを作成できませんでした',
  'project-fields.use-project-flags.project-tags-remove-failure-title': 'タグを削除できませんでした',
  'project-fields.use-project-flags.project-team-remove-failure-description':
    'チームの削除中にエラーが発生しました。もう一度お試しください',
  'project-fields.use-project-flags.related-project-remove-failure-title': '関連プロジェクトを削除できませんでした',
};
